
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
  watchEffect,
} from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Step1 from "@/views/pages/application/researchActivities/steps/Step1.vue";
import Step2 from "@/views/pages/application/researchActivities/steps/Step2.vue";
import Step3 from "@/views/pages/application/researchActivities/steps/Step3.vue";
import Step4 from "@/views/pages/application/researchActivities/steps/Step4.vue";
import { StepperComponent } from "@/assets/ts/components";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import { useForm } from "vee-validate";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Actions } from "@/store/enums/StoreEnums";
import router from "@/router";
import { getScrollTop } from "@/assets/ts/_utils";
import { useToast } from "vue-toastification";
import NoteSection from "@/components/sections/NoteSection.vue";

interface IStep1 {
  question: string;
  researchDesign: string;
  otherResearchDesign: string;
  isAnyIntervention: string;
  sumarizeIntervention: string;
  outcomes: string;
}

interface IStep2 {
  procedure: string;
  purpose: string;
  method: string;
}


interface CreateAccount extends IStep1, IStep2 {}

export default defineComponent({
  name: "kt-vertical-wizard",
  components: {
    Step1,
    Step2,
    Step3,
    Step4,
    NoteSection,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const toast = useToast();

    const _stepperObj = ref<StepperComponent | null>(null);
    const verticalWizardRef = ref<HTMLElement | null>(null);
    const currentStepIndex = ref(1);
    const jumped = ref(0);
    const fromJumpled = ref(0);
    const previewStep = ref(0);
    

    const currentResearch = computed(() => {
      return store.getters.currentResearch;
    });

    let formData = ref<CreateAccount>({
      purpose:
        currentResearch.value && currentResearch.value && currentResearch.value.data != null 
        && currentResearch.value.data.purpose != null && currentResearch.value.data.purpose != undefined?
        currentResearch.value.data.purpose:"",
      method:
        currentResearch.value && currentResearch.value.data && currentResearch.value.data != null
        && currentResearch.value.data.method != null && currentResearch.value.data.method != undefined?
        currentResearch.value.data.method:"",
      procedure:
        currentResearch.value && currentResearch.value.data && currentResearch.value.data != null
        && currentResearch.value.data.procedure != null && currentResearch.value.data.procedure != undefined?
        currentResearch.value.data.procedure:"",
      question:
        currentResearch.value && currentResearch.value.data && currentResearch.value.data != null
        && currentResearch.value.data.question != null && currentResearch.value.data.question != undefined?
        currentResearch.value.data.question:"",
      researchDesign:
        currentResearch.value && currentResearch.value.data && currentResearch.value.data != null
        && currentResearch.value.data.researchDesign != null && currentResearch.value.data.researchDesign != undefined?
        currentResearch.value.data.researchDesign:"",
      otherResearchDesign:
        currentResearch.value && currentResearch.value.data && currentResearch.value.data != null
        && currentResearch.value.data.otherResearchDesign != null && currentResearch.value.data.otherResearchDesign != undefined?
        currentResearch.value.data.otherResearchDesign:"",
      isAnyIntervention:
        currentResearch.value && currentResearch.value.data && currentResearch.value.data != null 
        && currentResearch.value.data.isAnyIntervention?
        "1":"",
      sumarizeIntervention:
        currentResearch.value && currentResearch.value.data && currentResearch.value.data != null
        && currentResearch.value.data.sumarizeIntervention != null && currentResearch.value.data.sumarizeIntervention != undefined?
        currentResearch.value.data.sumarizeIntervention:"",
      outcomes:
        currentResearch.value && currentResearch.value.data && currentResearch.value.data != null
        && currentResearch.value.data.outcomes != null && currentResearch.value.data.outcomes != undefined?
        currentResearch.value.data.outcomes:"",
    });

    onMounted(() => {
      store.dispatch(Actions.GET_IRB_APPLICATION_RESEARCH, route.params.id);

      _stepperObj.value = StepperComponent.createInsance(
        verticalWizardRef.value as HTMLElement
      );

      setCurrentPageBreadcrumbs("Vertical", ["Pages", "Wizards"]);
      if (route.query["step"] != null && route.query["step"] === "2" 
        ) {
        _stepperObj.value?.goNext();
        _stepperObj.value?.goNext();
        jumpToStep(2);
        jumped.value = 3;
        currentStepIndex.value = 3;
      }
    });

    const createAccountSchema = [
      Yup.object({
        question: Yup.string().required().label("Research Question"),
        researchDesign: Yup.string().required().label("Research Design"),        
        outcomes: Yup.string().required().label("Outcomes"),
      }),
      Yup.object({
        procedure: Yup.string().required().label("Describe Procedure"),
        purpose: Yup.string().required().label("Describe Purpose"),
        method: Yup.string().required().label("Describe Method"),
      }),
      Yup.object({

      }),
    ];

    const currentSchema = computed(() => {
      return createAccountSchema[currentStepIndex.value -1];
    });

    const { resetForm, handleSubmit } = useForm<IStep1 | IStep2>({
      validationSchema: currentSchema,
    });

    const totalSteps = computed(() => {
      if (!_stepperObj.value) {
        return;
      }

      return _stepperObj.value.totatStepsNumber;
    });

    resetForm({
      values: {
        ...formData.value,
      },
    });

    const handleStep = handleSubmit((values) => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      formData.value = {
        ...formData.value,
        ...values,
      };

      let data = currentResearch.value.data;
      const stepToUpdate = jumped.value === 1? previewStep.value: fromJumpled.value == 0? (currentStepIndex.value -1):currentStepIndex.value;
      router.push({query: { }});
      if (stepToUpdate === 0) {
        
        data.question = formData.value.question;
        data.researchDesign = formData.value.researchDesign;
        data.otherResearchDesign = formData.value.otherResearchDesign;
        data.isAnyIntervention = formData.value.isAnyIntervention == "1";
        data.sumarizeIntervention = formData.value.sumarizeIntervention;
        data.outcomes = formData.value.outcomes;
      } else if (stepToUpdate === 1) {
        data.purpose = formData.value.purpose;
        data.method = formData.value.method;
        data.procedure = formData.value.procedure;
        //router.push({query: { step: "2"}});
      }

      jumped.value = 0;
      fromJumpled.value = 0;
      if ([0, 1, 2, 3].indexOf(currentStepIndex.value) > -1) {
        const json = JSON.stringify(data);
        store
          .dispatch(Actions.POST_IRB_RESEARCH, json)
          .then(() => {
            if (currentStepIndex.value === 3) {
              toast.success("Information Saved", {
                timeout: 2000
              });
              router.push({
                  name: "edit-subject-define",
                  params: { id: route.params.id },
                });
            }
            currentStepIndex.value++;
            if (!_stepperObj.value) {
              return;
            }
            //_stepperObj.value.goNext();
            _stepperObj.value?.goto(currentStepIndex.value);
          })
          .catch(() => {
            toast.error(store.getters.getIrbError, {
                timeout: 2000
              });
            
          });
      }
    });

    const previousStep = () => {
      if (!_stepperObj.value) {
        return;
      }

      currentStepIndex.value--;

      _stepperObj.value.goPrev();
    };

    const jumpToStep = (step) => {
      jumped.value = 0;
      previewStep.value = (currentStepIndex.value-1);
      fromJumpled.value = 1;
      if ((step +1) !== currentStepIndex.value) {
        jumped.value = 1;
      } 
      currentStepIndex.value = step;
      document.getElementById("buttonSubmit")?.click();
      /*if (step !== currentStepIndex.value) {
        console.log("goto step");
        currentStepIndex.value = step;
        _stepperObj.value?.goto(step + 1);
      }*/
    };

    const formSubmit = () => {
      toast.success("Information Saved", {
                timeout: 2000
              });
              window.location.reload();
    };

    watchEffect(() => {
      const data = store.getters.currentResearch;
      if (data === null || data.data === undefined) return;
      // if (!_stepperObj.value) {
      //   return;
      // }

      // currentStepIndex.value = 2;

      // _stepperObj.value.goto(2);
    });

    watch(
      () => route.params.id,
      async () => {
        await store.dispatch(
          Actions.GET_IRB_APPLICATION_RESEARCH,
          route.params.id
        );
      }
    );

    return {
      formData,
      verticalWizardRef,
      jumpToStep,
      previousStep,
      handleStep,
      formSubmit,
      totalSteps,
      currentStepIndex,
    };
  },
});
